export function SixDiamonds(done: boolean) {
  return (
    <svg
      version="1.1"
      viewBox="0 0 1477 2048"
      width="fit-content"
      height="200"
      xmlns="http://www.w3.org/2000/svg"
    >
      {done ? (
        <>
          <path
            transform="translate(0)"
            d="m0 0h1477v2048h-1477z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(389,256)"
            d="m0 0 7 6 83 83v2l3 1v2l3 1v2l3 1 7 8 56 56 4 3-1 4-79 79-7 8-74 74h-2l-2 4-8-6-26-26-7-8-126-126 2-4 70-70 1-2h2l2-4 86-86z"
            fill="#E93829"
          />
          <path
            transform="translate(1075,1435)"
            d="m0 0 4 2 163 163-1 4-6 5-7 8-151 151-4-2-130-130-7-8-24-24-2-1v-3h2v-2l160-160z"
            fill="#E93829"
          />
          <path
            transform="translate(388,1435)"
            d="m0 0 4 1 16 17 148 148-5 5-16 17-145 145-4-2-121-121-4-5-5-4-7-8-26-26v-2l5-5z"
            fill="#E93829"
          />
          <path
            transform="translate(389,845)"
            d="m0 0 7 6 33 33 7 8 119 119-2 4-29 29-7 8-127 127-5-3-73-73-7-8-81-81 1-5z"
            fill="#E93829"
          />
          <path
            transform="translate(1075,845)"
            d="m0 0 4 2 7 8 156 156-2 4-82 82-7 8-70 70h-2l-1 3-3 1-60-60v-2l-3-1-4-5-98-98 2-4 150-150 4-5h2l2-4 4-2z"
            fill="#E93829"
          />
          <path
            transform="translate(1075,256)"
            d="m0 0 4 2 81 81v2l3 1v2l3 1v2l3 1v2h2l7 8 61 61 3 2-1 4-152 152-7 8-6 5-5-5-6-5-4-5-5-4-7-8-138-138-1-4 8-7 141-141 1-2h2l1-3h2l1-3h2l2-4 4-2z"
            fill="#E93829"
          />
          <path
            transform="translate(110,33)"
            d="m0 0h1247l20 1 12 4 10 6 7 6 7 10 5 11 2 15v1592l-1 99h-1l-1-169-1-1530-4-13-7-11-10-9-12-6-9-2-1168-1h-92l-24 1-13 4-10 6-8 8-6 10-4 12-1 7v1840l1 22 4 13 7 11 7 7 10 6 7 3 5 1 1255 1 32-1 10-3 11-6 6-5 7-10 5-11 2-13 1-48h1l1 5v44l-2 13-8 16-8 9-11 7-10 4-4 1-14 1h-1265l-15-2-9-4-11-7-9-10-7-14-2-12v-1856l2-14 5-12 6-8 8-8 12-7 11-3z"
            fill="#4A3942"
          />
          <path
            transform="translate(144,78)"
            d="m0 0h12l13 2 17 9 5 6 4 8 1 4v7l-4 4h-18l-6-4-5-7-6-3h-10l-10 3-6 5-7 14-4 17 15-7 11-2h12l16 4 14 12 6 10 5 12 2 11v14l-2 12-5 12-8 11-13 9-10 3-7 1h-17l-14-3-9-5-5-4v-2h-2l-7-9-5-9-4-13-3-18-1-23 3-28 7-20 9-14 9-9 16-8z"
            fill="#E93829"
          />
          <path
            transform="translate(1309,1779)"
            d="m0 0h16l14 3 10 5 9 8 7 10 6 15 4 21 1 24-2 20-2 11-7 20-8 11-10 10-14 7-12 2h-13l-13-2-15-8-6-7-4-9-1-9 2-4 5-1h15l8 7 4 5 5 2h12l9-3 5-5 8-16 3-15-15 7-11 2h-13l-12-3-7-4-10-9-6-10-4-9-3-16v-10l3-17 6-12 9-10 11-7z"
            fill="#E93829"
          />
          <path
            transform="translate(145,282)"
            d="m0 0 3 1 7 8 46 46-6 7-47 47-1 2-4-1-49-49-4-5 1-3 8-7 7-8 36-36z"
            fill="#E93829"
          />
          <path
            transform="translate(1319,1631)"
            d="m0 0 4 2 1 3h2l7 8 42 42-2 4-52 52-4-2-52-52 1-4z"
            fill="#E93829"
          />
          <path
            transform="translate(141,160)"
            d="m0 0h10l8 3 6 5 5 10 1 6v11l-3 11-4 6-6 5-9 3-10-1-7-4-6-7-4-8-1-4v-12l3-11 5-7 5-4z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(1317,1804)"
            d="m0 0 6 1 7 2 8 7 5 10 1 3v13l-2 9-5 8-6 5-6 2h-12l-8-3-6-7-4-9-1-5v-11l3-10 4-7h2v-2l7-4z"
            fill="#FDFDFD"
          />
        </>
      ) : (
        <>
          <path
            transform="translate(0)"
            d="m0 0h1475v2048h-1475z"
            fill="#FEFEFE"
          />
          <path
            transform="translate(0)"
            d="m0 0h1475v2048h-1475zm98 42-14 2-12 5-11 8-7 9-7 14-2 10v1867l2 11 8 16 6 7 13 9 10 4 5 1 1191 1h85l15-1 13-4 11-7 9-9 7-12 3-10 1-9v-1860l-2-14-8-16-12-12-16-8-14-2z"
            fill="#FEFEFE"
          />
          <path
            xmlns="http://www.w3.org/2000/svg"
            transform="translate(722,851)"
            d="m0 0 4 1 132 132v2l3 1v2l3 1v2l4 2 2 4h2l7 8 8 8-1 4-162 162-4-2v-2l-4-2-48-48v-2l-3-1v-2l-3-1v-2l-3-1v-2h-2l-7-8-91-91 3-5 144-144 1-2h2l2-4 5-5h2v-2z"
            fill="#EC3829"
          />
          <path
            transform="translate(98,42)"
            d="m0 0h1274l14 2 16 8 12 12 8 16 2 14v1860l-2 13-5 12-7 9-7 7-10 6-13 4-15 1h-85l-1191-1-13-4-11-7-5-5-7-8-6-13-2-11v-1867l2-10 8-16 7-8 10-7 12-5zm-6 3-12 3-11 6-9 8-8 13-3 8-1 6v1868l2 11 6 12 9 10 9 7 9 4 14 2h1274l14-2 9-4 9-6 8-8 6-11 3-10 1-8v-1862l-2-11-4-9-6-9-9-9-14-7-10-2z"
            fill="#414141"
          />
          <path
            transform="translate(46,425)"
            d="m0 0h1l1 1523 3 20 6 12 9 10 10 7 11 4 10 1h1274l14-2 9-4 9-6 7-7 6-11 3-10 1-8 1-1 1-12h1v22l-4 12-7 11-9 9-10 6-13 4-15 1h-85l-1191-1-13-4-11-7-5-5-7-8-6-13-2-11v-1531z"
            fill="#323232"
          />
          <path
            transform="translate(1423,94)"
            d="m0 0h1v1860l-3-1v-1857z"
            fill="#717171"
          />
          <path
            transform="translate(46,425)"
            d="m0 0h1l1 1523 3 20 6 12 9 10 10 7 11 4 10 1v1l-13 1-12-5-11-8-8-10-6-13-2-11v-1531z"
            fill="#262626"
          />
          <path
            transform="translate(45,90)"
            d="m0 0 3 1v1857h-1l-1-1522h-1z"
            fill="#6E6E6E"
          />
          <path
            transform="translate(1308,1859)"
            d="m0 0h29l1 4-10 35-4 16-2-1-12-45z"
            fill="#FEFEFE"
          />
          <path
            transform="translate(145,134)"
            d="m0 0 2 1 13 49 1 4h-30l2-9 9-34z"
            fill="#FEFEFE"
          />
          <path
            transform="translate(1422,1941)"
            d="m0 0h1v22l-4 12-7 11-9 9-10 6-13 4-15 1h-85l-137-1 1-2 227-1 14-2 9-4 9-6 7-7 6-11 3-10 1-8 1-1z"
            fill="#323232"
          />
          <path
            transform="translate(88,43)"
            d="m0 0h157v2l-153 1-12 3-11 6-8 7-8 13-3 8-2 8-1 9h-1v-17l5-12 6-9 5-6 10-7 12-5z"
            fill="#414141"
          />
          <path
            transform="translate(1422,1941)"
            d="m0 0h1v22l-4 12-7 11-9 9-10 6-9 3h-2l-1-3 10-3 11-7 8-8 6-11 3-10 1-8 1-1z"
            fill="#454545"
          />
          <path
            transform="translate(1384,44)"
            d="m0 0 9 3 10 6 11 11 8 16 1 4v13l-2-1-3-15-4-9-6-9-8-8-14-7-3-2z"
            fill="#3F3F3F"
          />
          <path
            transform="translate(49,1968)"
            d="m0 0h2l6 12 9 10 10 7 11 4 10 1v1l-13 1-12-5-11-8-8-10-5-10z"
            fill="#383838"
          />
          <path
            transform="translate(1423,94)"
            d="m0 0h1v53l-3 1v-52z"
            fill="#626262"
          />
          <path
            transform="translate(1409,1986)"
            d="m0 0v3l-9 8-12 6-6 1-1-3 10-3 15-9z"
            fill="#3E3E3E"
          />
          <path
            transform="translate(84,44)"
            d="m0 0 8 1v1l-12 3-11 6-5 2 2-4 10-6z"
            fill="#333"
          />
          <path
            transform="translate(50,76)"
            d="m0 0 1 4-3 11-1 9h-1v-17l2-6z"
            fill="#383838"
          />
          <path
            transform="translate(1422,1941)"
            d="m0 0h1v19l-3 3v-9l1-1z"
            fill="#3A3A3A"
          />
          <path
            transform="translate(78 2e3)"
            d="m0 0 9 1 10 1v1l-13 1-6-2z"
            fill="#3A3A3A"
          />
          <path
            transform="translate(1420,83)"
            d="m0 0 3 1v13l-2-1-1-4z"
            fill="#464646"
          />
          <path
            transform="translate(49,1968)"
            d="m0 0h2l4 8v3h-3l-4-8z"
            fill="#323232"
          />
          <path
            transform="translate(67,1994)"
            d="m0 0 6 1 7 4-4 2-9-6z"
            fill="#2C2C2C"
          />
          <path
            transform="translate(62,56)"
            d="m0 0 3 1-6 8-4 1 2-4z"
            fill="#393939"
          />
          <path
            transform="translate(1409,1986)"
            d="m0 0v3l-8 7h-3l1-3 6-3z"
            fill="#242424"
          />
          <path
            transform="translate(1413,1981)"
            d="m0 0 1 2-4 4-6 5-2-1 8-8z"
            fill="#3D3D3D"
          />
        </>
      )}
    </svg>
  );
}
